import { createAuthClient } from 'better-auth/react'

const API_URL = process.env.EXPO_PUBLIC_API_URL?.trim() ?? 'http://localhost:4000/trpc'
// API_URL points at /trpc — strip the suffix to get the BetterAuth /api/auth root.
const AUTH_BASE_URL = API_URL.replace(/\/trpc\/?$/, '')

export const authClient = createAuthClient({
  baseURL: AUTH_BASE_URL,
})

export const { signIn, signUp, signOut, useSession } = authClient
